<template>
	<div class="listbox">
		<div class="tabtit">
			<ul>
				<li><router-link to="/MyTailPays">补交尾款</router-link></li>
				<li><router-link to="/MyAuc">我的拍卖</router-link></li>
				<li class="hover"><router-link to="/MyReceive">我的领取</router-link></li>
			</ul>
		</div>
		<div class="tabcont">
			<div class="itembox active">
				<p class="listtitlq" :data="myReceives" size="mini">
					<span prop="productName" label="物品名称">物品名称</span>
					<span prop="productId" label="物品ID">物品ID</span>
					<span prop="aucEndTime" label="竞价时间">竞拍时间</span>
					<span prop="payMoney" label="保证金">保证金</span>
					<span prop="finalPrice" label="成交金额">成交金额</span>
					<span prop="unPrice" label="补款金额">补款金额</span>					
					<span prop="tailMoneyTime" label="补款时间">补款时间</span>
					<span prop="receiveApplyTime" label="领取时间">领取时间</span>
					<span label="领取确认">领取确认</span>
					<span prop="productStatus" label="状态">状态</span>
				</p>
				<div class="lqlist">
					<ul>
						<li v-for="item in myReceives" :key="item.id">
							<span class="span1">{{item.productName}}</span>
							<span class="span2">{{item.productId}}</span>
							<span class="span3">{{item.aucEndTime}}</span>
							<span class="span4">{{formatterPricelx(item.currencyType,item.payMoney)}}</span>
							<span class="span5">{{formatterPricelx(item.currencyType,item.finalPrice)}}</span>
							<span class="span6">{{formatterTailPricelx(item.currencyType,item.finalPrice,item.payMoney)}}</span>
							<span class="span7">{{item.tailMoneyTime}}</span>
							<span class="span8">{{item.receiveApplyTime}}</span>
							<span class="span9" v-if="item.productStatus == 2 || item.productStatus == '2'"><em class="click" @click="applyReceive(item)">申请领取</em></span>
							<span class="span9" v-else-if="item.productStatus == 3 || item.productStatus == '3'"><em class="hui">申请领取</em></span>
							<span class="span9" v-else-if="item.productStatus == 4 || item.productStatus == '4'"><em class="hui">申请领取</em></span>
							<span class="span10">{{formatterProductStatuszt(item.productStatus)}}</span>
						</li>
					</ul>
				</div>

				<div class="page">
					<el-pagination background @size-change="sizeChange" @current-change="currentChange" layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
				</div>
				<el-dialog :visible="fourIdDiaLogVisible" :title="dalogarr[info-1]" @close="fourIdDiaLogHandleClose" :before-close="fourIdDiaLogHandleClose">
				<el-form ref="form" :model="regDto"  :rules="rules" label-width="80px" size="mini">
					<el-input class="elinput" v-model="regDto.aucId" type="hidden"></el-input>
					<el-input class="elinput" v-model="regDto.newId" type="hidden"></el-input>
					<el-form-item label="您正在领取的ID是" prop="productName">
				     	<el-input class="elinput" disabled v-model="regDto.productName"></el-input>
					</el-form-item>
					<el-form-item label="密码(8-15位)" prop="newPwd">
					    <el-input  type="password" class="elinput" v-model="regDto.newPwd"></el-input>
					</el-form-item>
					<el-form-item label="请再次输入密码" prop="newPwd1">
					    <el-input  type="password" class="elinput" v-model="regDto.newPwd1"></el-input>
					</el-form-item>
					<el-form-item label="新账号二级密码(8-15位)" prop="newPwd2">
				     	<el-input   type="password" class="elinput" v-model="regDto.newPwd2"></el-input>
					</el-form-item>
					<el-form-item label="请再次输入新账号二级密码" prop="newPwd3">
					    <el-input  type="password" class="elinput" v-model="regDto.newPwd3"></el-input>
					</el-form-item>
					<el-form-item label="当前账号二级密码" >
				     	<el-input  type="password" class="elinput" v-model="regDto.pwd2"></el-input>
					</el-form-item>
					<el-form-item label="昵称" prop = 'newNickName'>
				     	<el-input class="elinput" v-model="regDto.newNickName"></el-input>
					</el-form-item>
					<el-form-item label="安全邮箱" prop = "email">
					    <el-input class="elinput" v-model="regDto.email"></el-input>
					</el-form-item>
					<el-form-item label="真实姓名" prop = 'newRealName'>
					    <el-input class="elinput" v-model="regDto.newRealName"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop = 'newIdc'>
				     	<el-input class="elinput" v-model="regDto.newIdc"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop = 'phone'>
				    	<el-input class="elinput" v-model="regDto.phone"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop = 'verificationCode'>
					    <el-input style="width:30%;float:left;" class="elinput" v-model="regDto.verificationCode"></el-input>
					<div @click="getIdentifyingCode(true)" style="float:left;padding-left:30px">
					<el-image class="imgverification"  :src="vcodeUrl" ></el-image>
					</div>
					</el-form-item>
					<el-form-item size="large">
					<el-button style="margin-left:35%" type="primary" @click="fourIdOnSubmit">立即注册</el-button>
					<el-button @click="fourIdDiaLogHandleClose">取消</el-button>
					</el-form-item>
				</el-form>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		//我的领取
		name: "MyReceive",
		data() {

			 var passworldfiled = (rule, value, callback) => {
				 if(value != this.regDto.newPwd){
					   callback(new Error('确认密码与密码不一致！'))
				 }else{
					 callback()
				 }
			}
			 var newpassworldfiled = (rule, value, callback) => {
				 if(value != this.regDto.newPwd2){
					   callback(new Error('确认密码与密码不一致！'))
				 }else{
					 callback()
				 }
			}
			return {
				//访问前缀，用于区分环境，访问api时使用
				service_url: process.env.VUE_APP_SERVICE_URL ? process.env.VUE_APP_SERVICE_URL : '',
				myReceives: [],
				total: 0,
				currentPage: 1,
				currentSize: 10,
				fourIdDiaLogVisible: false,
				regDto:{
					aucId: 0,
					verificationCode: '',
					pwd2:'',
					newId: '',
					//校验两次密码输入
					newPwd: '',
					newPwd1: '',
					//新账号的二级密码
					newPwd2: "",
					newIdc: "",
					newRealName: "",
					newNickName: "",
					email: "",
					phone: "",
					productName:'',
					newPwd3:''
				},
				vcodeUrl:"",
				info:1,
				dalogarr:['靓号领取注册','四位ID领取注册'],
			
				rules: {
					productName: [
						{ required: true, message: '请输入活动名称', trigger: 'blur' },
					],
					newPwd: [
						{ required: true, message: '请输入密码', trigger: 'blur' },
						{ min: 8, max: 15, message: '请输入正确格式密码', trigger: 'blur' }
					],
					newPwd1: [
						{  required: true, message: '请再次输入新账号二级密码', trigger: 'blur' },
						{ validator: passworldfiled, trigger: 'blur' }
					],
					newPwd2: [
						{  required: true, message: '请输入新账号二级密码', trigger: 'blur' },
						{ min: 8, max: 15, message: '请输入正确格式密码', trigger: 'blur' }
					],
					newPwd3: [
						{  required: true, message: '请再次输入新账号二级密码', trigger: 'blur' },
						{ validator: newpassworldfiled, trigger: 'blur' }
					],
					newNickName: [
						{ required: true, message: '请输入昵称', trigger: 'blur' },
						{ min: 2, max: 19, message: '请输入正确格式昵称', trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请填写活动形式', trigger: 'blur' },
					    {
							required: true,
							pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
							message: '请输入正确邮箱',
							trigger: 'blur'
						}
					],
					newRealName: [ 
						{ required: true, message: '请输入真实姓名', trigger: 'blur' },
					
					],
					newIdc: [
						{ required: true, message: '请输入身份证号', trigger: 'blur' },
					    { min: 15, max: 18, message: '请如实填写18位号码', trigger: 'blur' },
						{
							required: true,
							pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
							message: '请输入正确的身份证号码',
							trigger: 'blur'
						}
					],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{
							required: true,
							pattern:  /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/,
							message: '请输入正确手机号',
							trigger: 'blur'
						}
					],
					verificationCode: [
						{ required: true, message: '请填写活动形式', trigger: 'blur' },
						{ min: 4, max: 4, message: '请输入正确格式验证码', trigger: 'blur' }
					],
				}
			};
		},
		methods: {
			sizeChange(size) {
				this.currentSize = size;
				this.initReceives();
			},
			currentChange(page) {
				this.currentPage = page;
				this.initReceives();
			},
		
			initReceives() {
				this.getRequest(this.service_url + "/aucProduct/applyReceivePage?current=" + this.currentPage + '&size=' + this.currentSize).then(resp => {
					if (resp) {
						this.myReceives = resp.data.records;
						this.total = resp.data.total;
					}
				})
			},
			formatterTailPricelx: function(currencyType,finalPrice,payMoney) {
				if (currencyType == "0" || currencyType == 0) {
					return (finalPrice - payMoney) + "联众币";
				} else if (currencyType == "1" || currencyType == 1) {
					return (finalPrice - payMoney) + "游乐豆";
				} else if (currencyType == "2" || currencyType == 2) {
					return (finalPrice - payMoney) + "天(会员天数)";
				} else if (currencyType == "3" || currencyType == 3) {
                    return (finalPrice - payMoney) + "天(可转移会员天数)";
                }
			},
			formatterPricelx: function(currencyType,Price) {
				if (currencyType == "0" || currencyType == 0) {
					return Price + "联众币";
				} else if (currencyType == "1" || currencyType == 1) {
					return Price + "游乐豆";
				} else if (currencyType == "2" || currencyType == 2) {
					return Price + "天(会员天数)";
				} else if (currencyType == "3" || currencyType == 3) {
                    return Price + "天(可转移会员天数)";
                }
			},
			formatterProductStatuszt: function(cellValue) {
				if (cellValue == "2" || cellValue == 2) {
					return "待发起领取申请";
				}
				if (cellValue == "3" || cellValue == 3) {
					return "等待处理";
				}
				if (cellValue == "4" || cellValue == 4) {
					return "领取成功";
				}
			},
			applyReceive(product) {
				//4位Id直接弹出框走注册逻辑
				debugger
				if (product.productType == 2 || product.productType == 1) {
					this.regDto.aucId = product.id;
					this.regDto.newId = product.productId;
					this.regDto.productName = product.productName;
					this.info = product.productType
					//弹出
					this.fourIdDiaLogVisible = true;
					this.$nextTick(() =>{
	                   this.$refs['form'].resetFields();
					})
					//验证码切换
					this.getIdentifyingCode(true);
					return;
				}
				//其他的走申请领取接口
				this.getRequest(this.service_url + "/aucProduct/applyReceive/" + product.id).then(resp => {
					if (resp && resp.code == 0) {
						//刷新页面状态
						this.initReceives();
					}
					if (resp && resp.code == 20001) {
						//竞拍产品未找到
						this.$message.error(resp.msg);
					}
				})
			},
			fourIdDiaLogHandleClose() {
				this.fourIdDiaLogVisible = false;
			},
            received(url){
            this.postRequest(this.service_url + url , this.regDto).then(resp => {
						if (resp && resp.code == 0) {
							//刷新页面状态
							this.initReceives();
							this.fourIdDiaLogVisible = false;
							this.$message({
								showClose: true,
								message: resp.msg,
								type: 'success'
							})
						}
						//二级密码错误
						if (resp && resp.code == 9) {
							this.$message.error(resp.msg);
						}
						//验证码错误
						if (resp && resp.code == 10) {
							this.$message.error(resp.msg);
						}
					})
			},
			// 提交新账号数据
			fourIdOnSubmit(){
				if(this.info == 2){
					this.received( "/aucProduct/receiveFourId")
				}else{
					this.received('/aucProduct/receive3Id')
				}
			},
			getIdentifyingCode: function (bRefresh) {
				let identifyCodeSrc = this.service_url + "/common/VCode";
				if (bRefresh) {
					identifyCodeSrc = this.service_url + "/common/VCode?" + Math.random();
				}
				this.vcodeUrl = identifyCodeSrc;
			},
		},
		mounted() {
			this.initReceives();
		},
		components: {

		}
	};
</script>
<style>
	.listbox { width: 1008px; margin: 0 auto; padding-top: 30px; }
	.tabtit { height: 50px; line-height: 50px; overflow: hidden; border-bottom: 1px #ce2c00 solid; }
	.tabtit ul { height: 50px; line-height: 50px; overflow: hidden; }
	.tabtit li { width: 134px; height: 50px; border: 1px #f0f0f0 solid; text-align: center; line-height: 50px; float: left; color: #151515; cursor: pointer; font-size: 14px; }
	.tabtit li a { display: block; width: 134px; height: 50px; color: #151515; text-decoration: none; }
	.tabtit li.hover { background: #ce2c00; color: #fff; }
	.tabtit li.hover a { color: #fff; }
	.tabcont { padding-top: 38px; }
	.tabcont .itembox { display: none; width: 958px; margin: 0 auto; }
	.tabcont .active { display: block; }
	.tabcont .itembox .listtit { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listtit span { display: block; float: left; width: 119px; text-align: center; line-height: 38px; font-size: 14px; }
	.tabcont .itembox .listtitlq { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listtitlq span { display: block; float: left; width: 95px; text-align: center; line-height: 38px; font-size: 14px; }
	.lqlist { width: 956px; margin: 0 auto; border-left: 1px #dcdcdc solid; border-right: 1px #dcdcdc solid; }
	.lqlist ul {}
	.lqlist ul li { height: 34px; overflow: hidden; line-height: 34px; font-size: 12px; color: #333; border-bottom: 1px #ccc solid; }
	.lqlist ul li span { display: block; text-align: center; line-height: 30px; height: 34px; float: left; }
	.lqlist ul li .span1 { width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.lqlist ul li .span2 { width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.lqlist ul li .span3 { width: 95px; line-height: 16px; }
	.lqlist ul li .span4 { width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.lqlist ul li .span5 { width: 95px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.lqlist ul li .span6 { width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.lqlist ul li .span7 { width: 100px; line-height: 16px; }
	.lqlist ul li .span8 { width: 93px; line-height: 16px; }
	.lqlist ul li .span9 { width: 90px; }
	.lqlist ul li .span9 em { display: block; width: 62px; height: 24px; text-align: center; line-height: 24px; color: #fff; font-size: 12px; margin: 5px auto 0; }
	.lqlist ul li .span9 em.click { cursor: pointer; background: #d90000; }
	.lqlist ul li .span9 em.hui { background: #929292; }
	.lqlist ul li .span10 { width: 103px; }
	.lqlist ul li:nth-child(even) { background: #f8f8f8; }
	.page { padding: 15px 0; text-align: center; }
	.page .el-pagination__rightwrapper,.page .el-pagination__sizes,.page .el-pagination__jump { display: none; }
	.el-pagination span:not([class*=suffix]) {  display: none; }
	.el-pager li { float: left; }
	.elinput{
		width:70%
	}
	.el-form-item__label{
		width:27%!important
	}
	.imgverification{
		height:30px;
		object-fit: fill;
	}
</style>